<template>
    <product v-bind="props"></product>
</template>

<script setup>
import Product from '../Product.vue';
const props = defineProps({
    product: Object,
    expedition: Number,
    alsoLike: {
        type: Array,
        default: [],
    },
    navigation: {
        type: Object,
        default: null,
    },
});
</script>

<style scoped lang="scss">

</style>
